import { render, staticRenderFns } from "./ResultCheckPriceDetail.vue?vue&type=template&id=3874808a&scoped=true&"
import script from "./ResultCheckPriceDetail.vue?vue&type=script&lang=js&"
export * from "./ResultCheckPriceDetail.vue?vue&type=script&lang=js&"
import style0 from "./ResultCheckPriceDetail.vue?vue&type=style&index=0&id=3874808a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3874808a",
  null
  
)

export default component.exports